import type { IntlShape } from 'react-intl';

import { PositionType } from '~/redux/api/types/playbooks/guidelines';

export const getVariationLevelLabel = (
  level: PositionType,
  intl: IntlShape,
) => {
  switch (level) {
    case 'Preferred':
      return intl.formatMessage({
        id: 'Guideline.variation.level.preferred',
        defaultMessage: 'Preferred',
        description: 'Label for preferred clause variation level',
      });
    case 'Fallback':
      return intl.formatMessage({
        id: 'Guideline.variation.level.fallback',
        defaultMessage: 'Fallback',
        description: 'Label for fallback clause variation level',
      });
    case 'Walk away':
      return intl.formatMessage({
        id: 'Guideline.variation.level.walkAway',
        defaultMessage: 'Walk Away',
        description: 'Label for walk away clause variation level',
      });
    default:
      return '';
  }
};
